export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=4021cd8fef762789facd121ccbd7748d67d55cb8c8&name=addToFolderEventAction!'